// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`render 1`] = `
Object {
  "asFragment": [Function],
  "baseElement": <body>
    <div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
      >
        <div
          class="MuiGrid-root MuiGrid-item"
        >
          <h2
            class="MuiTypography-root MuiTypography-h2"
          >
            Select claims to include
          </h2>
          <p
            class="MuiTypography-root MuiTypography-body1"
          >
            The private billing amounts shown are the advised rates from 
            BCMA
            .
          </p>
        </div>
        <div
          class="MuiGrid-root MuiGrid-item"
        >
          <div
            class="MuiTableContainer-root"
          >
            <table
              aria-label="enhanced table"
              aria-labelledby="tableTitle"
              class="MuiTable-root makeStyles-table-2"
            >
              <thead
                class="MuiTableHead-root"
              >
                <tr
                  class="MuiTableRow-root MuiTableRow-head"
                >
                  <th
                    class="MuiTableCell-root MuiTableCell-head MuiTableCell-paddingCheckbox"
                    scope="col"
                  >
                    <span
                      aria-disabled="false"
                      class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                    >
                      <span
                        class="MuiIconButton-label"
                      >
                        <input
                          class="PrivateSwitchBase-input-9"
                          data-indeterminate="false"
                          type="checkbox"
                          value=""
                        />
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                          />
                        </svg>
                      </span>
                      <span
                        class="MuiTouchRipple-root"
                      />
                    </span>
                  </th>
                  <th
                    class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignLeft MuiTableCell-paddingNone"
                    scope="col"
                  >
                    Status
                  </th>
                  <th
                    class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                    scope="col"
                  >
                    Date of service
                  </th>
                  <th
                    class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                    scope="col"
                  >
                    Code
                  </th>
                  <th
                    class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignLeft"
                    scope="col"
                  >
                    Description
                  </th>
                  <th
                    class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                    scope="col"
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody
                class="MuiTableBody-root"
              >
                <tr
                  aria-checked="false"
                  class="MuiTableRow-root MuiTableRow-hover"
                  role="checkbox"
                  tabindex="-1"
                >
                  <td
                    class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-paddingCheckbox"
                  >
                    <span
                      aria-disabled="false"
                      class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                    >
                      <span
                        class="MuiIconButton-label"
                      >
                        <input
                          aria-labelledby="enhanced-table-checkbox-0"
                          class="PrivateSwitchBase-input-9"
                          data-indeterminate="false"
                          type="checkbox"
                          value=""
                        />
                        <svg
                          aria-hidden="true"
                          class="MuiSvgIcon-root"
                          focusable="false"
                          viewBox="0 0 24 24"
                        >
                          <path
                            d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                          />
                        </svg>
                      </span>
                      <span
                        class="MuiTouchRipple-root"
                      />
                    </span>
                  </td>
                  <th
                    class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-paddingNone"
                    id="enhanced-table-checkbox-0"
                    role="cell"
                    scope="row"
                  >
                    Submitted
                  </th>
                  <td
                    class="MuiTableCell-root MuiTableCell-body makeStyles-dateCell-5 MuiTableCell-alignRight"
                  >
                    19 Jan 1970
                  </td>
                  <td
                    class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-alignRight"
                  >
                    00311
                  </td>
                  <td
                    class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root"
                    >
                      <div
                        class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiInput-input"
                          name="description"
                          type="text"
                          value="Billing code title"
                        />
                      </div>
                    </div>
                  </td>
                  <td
                    class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-alignRight"
                  >
                    <div
                      class="MuiFormControl-root MuiTextField-root"
                    >
                      <div
                        class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                      >
                        <input
                          aria-invalid="false"
                          class="MuiInputBase-input MuiInput-input"
                          name="privateBillingAmount"
                          style="text-align: right;"
                          type="text"
                          value="123.45"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
        >
          <div
            class="MuiCardActions-root MuiCardActions-spacing"
          >
            <button
              class="MuiButtonBase-root MuiButton-root MuiButton-text"
              tabindex="0"
              type="button"
            >
              <span
                class="MuiButton-label"
              >
                Cancel
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </button>
            <button
              class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
              tabindex="0"
              type="button"
            >
              <span
                class="MuiButton-label"
              >
                Next
              </span>
              <span
                class="MuiTouchRipple-root"
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  </body>,
  "container": <div>
    <div
      class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-3 MuiGrid-item"
    >
      <div
        class="MuiGrid-root MuiGrid-item"
      >
        <h2
          class="MuiTypography-root MuiTypography-h2"
        >
          Select claims to include
        </h2>
        <p
          class="MuiTypography-root MuiTypography-body1"
        >
          The private billing amounts shown are the advised rates from 
          BCMA
          .
        </p>
      </div>
      <div
        class="MuiGrid-root MuiGrid-item"
      >
        <div
          class="MuiTableContainer-root"
        >
          <table
            aria-label="enhanced table"
            aria-labelledby="tableTitle"
            class="MuiTable-root makeStyles-table-2"
          >
            <thead
              class="MuiTableHead-root"
            >
              <tr
                class="MuiTableRow-root MuiTableRow-head"
              >
                <th
                  class="MuiTableCell-root MuiTableCell-head MuiTableCell-paddingCheckbox"
                  scope="col"
                >
                  <span
                    aria-disabled="false"
                    class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <input
                        class="PrivateSwitchBase-input-9"
                        data-indeterminate="false"
                        type="checkbox"
                        value=""
                      />
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                        />
                      </svg>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </span>
                </th>
                <th
                  class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignLeft MuiTableCell-paddingNone"
                  scope="col"
                >
                  Status
                </th>
                <th
                  class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                  scope="col"
                >
                  Date of service
                </th>
                <th
                  class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                  scope="col"
                >
                  Code
                </th>
                <th
                  class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignLeft"
                  scope="col"
                >
                  Description
                </th>
                <th
                  class="MuiTableCell-root MuiTableCell-head makeStyles-cell-3 MuiTableCell-alignRight"
                  scope="col"
                >
                  Amount
                </th>
              </tr>
            </thead>
            <tbody
              class="MuiTableBody-root"
            >
              <tr
                aria-checked="false"
                class="MuiTableRow-root MuiTableRow-hover"
                role="checkbox"
                tabindex="-1"
              >
                <td
                  class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-paddingCheckbox"
                >
                  <span
                    aria-disabled="false"
                    class="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiCheckbox-root MuiCheckbox-colorSecondary MuiIconButton-colorSecondary"
                  >
                    <span
                      class="MuiIconButton-label"
                    >
                      <input
                        aria-labelledby="enhanced-table-checkbox-0"
                        class="PrivateSwitchBase-input-9"
                        data-indeterminate="false"
                        type="checkbox"
                        value=""
                      />
                      <svg
                        aria-hidden="true"
                        class="MuiSvgIcon-root"
                        focusable="false"
                        viewBox="0 0 24 24"
                      >
                        <path
                          d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
                        />
                      </svg>
                    </span>
                    <span
                      class="MuiTouchRipple-root"
                    />
                  </span>
                </td>
                <th
                  class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-paddingNone"
                  id="enhanced-table-checkbox-0"
                  role="cell"
                  scope="row"
                >
                  Submitted
                </th>
                <td
                  class="MuiTableCell-root MuiTableCell-body makeStyles-dateCell-5 MuiTableCell-alignRight"
                >
                  19 Jan 1970
                </td>
                <td
                  class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-alignRight"
                >
                  00311
                </td>
                <td
                  class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root"
                  >
                    <div
                      class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiInput-input"
                        name="description"
                        type="text"
                        value="Billing code title"
                      />
                    </div>
                  </div>
                </td>
                <td
                  class="MuiTableCell-root MuiTableCell-body makeStyles-cell-3 MuiTableCell-alignRight"
                >
                  <div
                    class="MuiFormControl-root MuiTextField-root"
                  >
                    <div
                      class="MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl"
                    >
                      <input
                        aria-invalid="false"
                        class="MuiInputBase-input MuiInput-input"
                        name="privateBillingAmount"
                        style="text-align: right;"
                        type="text"
                        value="123.45"
                      />
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="MuiGrid-root MuiGrid-container MuiGrid-item MuiGrid-justify-xs-flex-end MuiGrid-grid-xs-12"
      >
        <div
          class="MuiCardActions-root MuiCardActions-spacing"
        >
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-text"
            tabindex="0"
            type="button"
          >
            <span
              class="MuiButton-label"
            >
              Cancel
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </button>
          <button
            class="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary"
            tabindex="0"
            type="button"
          >
            <span
              class="MuiButton-label"
            >
              Next
            </span>
            <span
              class="MuiTouchRipple-root"
            />
          </button>
        </div>
      </div>
    </div>
  </div>,
  "debug": [Function],
  "findAllByAltText": [Function],
  "findAllByDisplayValue": [Function],
  "findAllByLabelText": [Function],
  "findAllByPlaceholderText": [Function],
  "findAllByRole": [Function],
  "findAllByTestId": [Function],
  "findAllByText": [Function],
  "findAllByTitle": [Function],
  "findByAltText": [Function],
  "findByDisplayValue": [Function],
  "findByLabelText": [Function],
  "findByPlaceholderText": [Function],
  "findByRole": [Function],
  "findByTestId": [Function],
  "findByText": [Function],
  "findByTitle": [Function],
  "getAllByAltText": [Function],
  "getAllByDisplayValue": [Function],
  "getAllByLabelText": [Function],
  "getAllByPlaceholderText": [Function],
  "getAllByRole": [Function],
  "getAllByTestId": [Function],
  "getAllByText": [Function],
  "getAllByTitle": [Function],
  "getByAltText": [Function],
  "getByDisplayValue": [Function],
  "getByLabelText": [Function],
  "getByPlaceholderText": [Function],
  "getByRole": [Function],
  "getByTestId": [Function],
  "getByText": [Function],
  "getByTitle": [Function],
  "queryAllByAltText": [Function],
  "queryAllByDisplayValue": [Function],
  "queryAllByLabelText": [Function],
  "queryAllByPlaceholderText": [Function],
  "queryAllByRole": [Function],
  "queryAllByTestId": [Function],
  "queryAllByText": [Function],
  "queryAllByTitle": [Function],
  "queryByAltText": [Function],
  "queryByDisplayValue": [Function],
  "queryByLabelText": [Function],
  "queryByPlaceholderText": [Function],
  "queryByRole": [Function],
  "queryByTestId": [Function],
  "queryByText": [Function],
  "queryByTitle": [Function],
  "rerender": [Function],
  "unmount": [Function],
}
`;
